import { render } from "./test-series-list.vue?vue&type=template&id=5028760d&scoped=true"
import script from "./test-series-list.vue?vue&type=script&lang=js"
export * from "./test-series-list.vue?vue&type=script&lang=js"

import "./test-series-list.vue?vue&type=style&index=0&id=5028760d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5028760d"]])

export default __exports__